import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"support-introduction"},[_c(VRow,[_c(VCol,{attrs:{"md":"12","lg":"9"}},[_c('p',[_vm._v(" Du hast Probleme mit der App oder den Inhalten? Etwas funktioniert nicht so, wie du es dir vorstellst? ")]),_c('p',[_vm._v(" Eine Antwort kann ein paar Stunden (max. 48 Stunden) dauern, aber wir antworten dir auf jeden Fall. ")]),_c('create-support-message-dialog',[_c('a-trigger-primary-process-button',[_vm._v(" Support anfordern ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }